import { blue60 } from '../../../colors/blue';
import { gray35 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var MuiToggleButtonGroup = {
    styleOverrides: {
        root: {
            '& [class*=MuiToggleButton-root]': {
                borderColor: gray35,
            },
        },
        groupedHorizontal: {
            '&[class*=Mui-selected]:not(:first-of-type)': {
                borderLeft: "".concat(rem(1), " solid ").concat(blue60),
            },
            '&:active:not(:first-of-type)': {
                borderLeft: "".concat(rem(1), " solid ").concat(blue60),
            },
            '&:active:not(:last-child)': {
                borderRight: "".concat(rem(1), " solid ").concat(blue60),
            },
            '&:not(:last-child):not([class*=Mui-selected]):not(:active)': {
                borderRightColor: 'transparent',
            },
        },
    },
};
